import { InterfaceTab, tabType } from '#/types/types';

export class TabRenderer {
    private ircClient: any;

    constructor(ircClient: any) {
        this.ircClient = ircClient;
    }

    renderTab(tab: InterfaceTab): void {
        if (!tab) return;

        const existingTab = document.querySelector(`.irc-tab[data-tab-id="${tab.key}"]`);
        if (existingTab) return;

        const tabBar = document.getElementById('irc-tabbar');
        if (!tabBar) return;

        const tabElement = document.createElement('button');
        tabElement.className = 'irc-tab';
        tabElement.dataset.tabId = tab.type + ':' + tab.name.toLowerCase();

        const iconElement = document.createElement('img');
        iconElement.className = 'irc-tab-icon';

        let displayName = tab.name;
        let iconPath = '';

        switch (tab.type) {
            case tabType.QUERY:
                iconPath = 'img/query.png';
                break;
            case tabType.STATUS:
                iconPath = 'img/status.png';
                break;
            case tabType.CHANNEL:
                iconPath = 'img/channel.png';
                displayName = tab.name;
                break;
            case tabType.CHANNEL_LIST:
                iconPath = 'img/channel_list.png';
                break;
            default:
                iconPath = 'img/generic.png';
                break;
        }

        iconElement.src = iconPath;
        tabElement.appendChild(iconElement);

        const textElement = document.createElement('span');
        textElement.className = 'irc-tab-text';
        textElement.textContent = displayName;
        tabElement.appendChild(textElement);

        if (tab.type !== tabType.STATUS && tab.type !== tabType.SETTINGS) {
            tabElement.draggable = false;
            tabElement.classList.add('draggable');
            this.ircClient.clientEventManager.addDragListeners(tabElement);

            const closeBtn = document.createElement('span');
            closeBtn.className = 'irc-tab-close';
            closeBtn.textContent = '×';
            tabElement.appendChild(closeBtn);
        }

        tabBar.appendChild(tabElement);
    }

    removeTabElement(tab: InterfaceTab): void {
        const tabElement = document.querySelector(`.irc-tab[data-tab-id="${tab.key}"]`);
        if (tabElement) {
            tabElement.remove();
        }
    }

    updateTabElementName(oldKey: string, newKey: string, newName: string): void {
        const tabElement = document.querySelector(`.irc-tab[data-tab-id="${oldKey}"]`) as HTMLElement;
        const paneElement = document.querySelector(`.irc-pane[data-tab-id="${oldKey}"]`) as HTMLElement;

        if (tabElement) {
            tabElement.dataset.tabId = newKey;
            const textElement = tabElement.querySelector('.irc-tab-text');
            if (textElement) {
                textElement.textContent = newName;
            }
        }
        if (paneElement) {
            paneElement.dataset.tabId = newKey;
        }
    }

    updateActiveTab(tab: InterfaceTab): void {
        document.querySelectorAll('.irc-tab').forEach(tab => {
            tab.classList.remove('active');
        });

        document.querySelectorAll('.irc-pane').forEach(pane => {
            (pane as HTMLElement).style.display = 'none';
        });

        const activeTab = document.querySelector(`[data-tab-id="${tab.key}"]`);
        const activePane = document.querySelector(`.irc-pane[data-tab-id="${tab.key}"]`) as HTMLElement;

        if (activeTab && activePane) {
            activeTab.classList.add('active');
            activePane.style.display = 'flex';
            const messageBox = document.querySelector(`.irc-pane[data-tab-id="${tab.key}"] .irc-input`) as HTMLElement;
            if (messageBox) messageBox.focus();
        }
    }
}